// extracted by mini-css-extract-plugin
export var desc = "productHighlight-module--desc--fca7d";
export var header = "productHighlight-module--header--3ab8b";
export var icon = "productHighlight-module--icon--3893c";
export var item = "productHighlight-module--item--f6f51";
export var items = "productHighlight-module--items--4df06";
export var number = "productHighlight-module--number--bd145";
export var productHighlight = "productHighlight-module--productHighlight--30049";
export var withNumber = "productHighlight-module--withNumber--89a3e";